export * from '../overrides/bluex-sticky';

// soon to be depricated.
import { BluexSticky } from '../overrides/bluex-sticky';

export default BluexSticky
